import React from "react";
import { Container, Typography, Box, Paper, List, ListItem, ListItemIcon, ListItemText, Divider, Alert, Chip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faClipboardList, faExclamationTriangle, faCheckCircle, faSeedling, faGavel, faRetweet, faFileAlt } from "@fortawesome/free-solid-svg-icons";
import SectionTitle from "../../components/layouts/others/title-section.layout";

const POST20231203: React.FC = () => {
    return (
        <Container sx={{ mb: 5 }}>
            <SectionTitle title={"ESPACE INFORMATIONS DES HABITANTS"} />
            <Box mt={3}>
                <Typography
                    variant="h6"
                    fontWeight={700}
                    align="center"
                    gutterBottom
                    color="primary"
                >
                    Convention avec une SAFER (2)
                </Typography>
            </Box>

            <Paper elevation={2} sx={{ p: 3, mt: 2, backgroundColor: "#f9fbe7" }}>
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <FontAwesomeIcon icon={faInfoCircle} color="#4169e1" />
                    <Typography variant="subtitle1" fontWeight="bold">
                        Contexte de la convention
                    </Typography>
                </Box>
                <Typography variant="body1" gutterBottom>
                    Fidèle à ses méthodes, le Maire avait inscrit à l'ordre du jour du conseil municipal (CM) du <strong>9 novembre 2023</strong> une convention avec la SAFER IDF, <b>sans concertation, ni information</b>. La signature a finalement été reportée au CM de décembre 2023.<br /><br />
                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                        <FontAwesomeIcon icon={faExclamationTriangle} color="#e65100" />
                        <Typography variant="body2" sx={{ ml: 1 }}>
                            <b>Le lien de confiance étant rompu et la convention trop imprécise, appel à vigilance&nbsp;!
                            </b>
                        </Typography>
                    </Box>
                    Plusieurs questions essentielles n’avaient pas de réponse :
                </Typography>
                <List dense>
                    <ListItem>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faClipboardList} color="#0288d1" />
                        </ListItemIcon>
                        <ListItemText primary="Quel est le besoin précis de la commune ?" />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faGavel} color="#7cb342" />
                        </ListItemIcon>
                        <ListItemText primary="Quelle stratégie pour le droit de préemption ?" />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faFileAlt} color="#b71c1c" />
                        </ListItemIcon>
                        <ListItemText primary="Quels critères pour les préemptions ?" />
                    </ListItem>
                </List>
                <Typography variant="body2" color="text.secondary">
                    Rien dans la convention ne permettait de répondre : sentiment d’improvisation…
                </Typography>
            </Paper>

            <Divider sx={{ my: 3 }} />

            <Box mb={2}>
                <Typography variant="subtitle1" fontWeight={700}>
                    Nos deux propositions principales :
                </Typography>
                <List>
                    <ListItem alignItems="flex-start">
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faSeedling} color="#388e3c" />
                        </ListItemIcon>
                        <ListItemText
                            primary={<b>PLUi.</b>}
                            secondary={
                                <>
                                    <Typography component="span" variant="body2">
                                        Établir une carte des continuités écologiques et réservoirs de biodiversité (atlas ABC), et proposer son intégration au PLUi (zonage nature, ENS, OAP thématique sur BLR, etc.) pour renforcer la protection des parcelles naturelles.
                                    </Typography>
                                </>
                            }
                        />
                    </ListItem>
                    <ListItem alignItems="flex-start">
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faGavel} color="#7cb342" />
                        </ListItemIcon>
                        <ListItemText
                            primary={<b>SAFER.</b>}
                            secondary={
                                <>
                                    <Typography component="span" variant="body2">
                                        Amender la convention avec des garde-fous :
                                        <ul style={{ margin: "0 0 0 24px" }}>
                                            <li>Rachats <b>uniquement</b> à la demande de la municipalité.</li>
                                            <li>Rétrocession potentielle aux associations/environnement : <b>liste exhaustive et modalités à fixer</b>.</li>
                                            <li>Interdiction de rétrocession à un foncier public, bailleur ou promoteur.</li>
                                            <li>Pas d’« échanges de compensation ».</li>
                                            <li>Préservation <b>systématique</b> des parcelles de tout usage inadéquat.</li>
                                            <li>Convention renouvelable jusqu’à l’approbation du PLUi.</li>
                                        </ul>
                                    </Typography>
                                </>
                            }
                        />
                    </ListItem>
                </List>
            </Box>

            <Paper variant="outlined" sx={{ backgroundColor: "#eee", p: 2, mb: 2 }}>
                <Typography variant="subtitle2" fontWeight={700} mb={1} color="primary">
                    Question à suivre&nbsp;:
                </Typography>
                <Typography variant="body2">
                    Une fois le PLUi applicable (&nbsp;<b>prévu en 2025</b>&nbsp;), la municipalité pourra-t-elle et aura-t-elle intérêt à intégrer de nouveaux bois privés dans le patrimoine communal, alors qu’ils seraient déjà protégés par leur nouveau classement&nbsp;?
                </Typography>
            </Paper>

            <Box mb={3}>
                <Alert severity="info" iconMapping={{ info: <FontAwesomeIcon icon={faCheckCircle} color="#4caf50" /> }}>
                    <Typography variant="body2">
                        <b>Présentation de la nouvelle convention</b> : elle devra être validée par <b>tous les membres</b> du Groupe de Travail Développement Durable (GT DD).
                    </Typography>
                </Alert>
            </Box>

            <Alert severity="warning" iconMapping={{ warning: <FontAwesomeIcon icon={faExclamationTriangle} color="#ff7043" /> }}>
                <Typography variant="body1" fontWeight={700}>
                    Nous appelons d'ores et déjà les habitants et leurs représentants à <b>refuser cette convention SAFER</b>, du moins dans sa forme actuelle.
                </Typography>
            </Alert>
        </Container>
    );
};

export default POST20231203;